/******/ (() => { // webpackBootstrap
/*!************************************************!*\
  !*** ./zrc/scripts/general/card-alignments.js ***!
  \************************************************/
/* eslint-disable promise/catch-or-return */

window.setHeightCardTexts = function (nodeElementsArray) {
  var cssVariable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var setMaxHeightElements = elements => {
    var maxValue = 0;
    if (options == null) {
      elements.forEach(element => {
        if (element.offsetHeight > maxValue) {
          maxValue = element.offsetHeight;
        }
      });
      elements.forEach(element => {
        element.style.setProperty(cssVariable, "".concat(maxValue, "px"));
      });
    } else {
      // Convertir lista de nodos en array
      var arrayElements = Array.from(elements);
      var groupsElements = [];
      var columns = options[0].columns;

      // Encontrar el viewport actual para saber cuantas columnas hay
      options.forEach(object => {
        if (window.innerWidth <= object.breakpoint) {
          columns = object.columns;
        }
      });

      // subdividir todos los elementos en grupos, relativo a las columnas del grid
      var totalItems = arrayElements.length;
      while (totalItems !== 0) {
        var lastGroup = arrayElements.splice(0, columns);
        groupsElements.push(lastGroup);
        totalItems = arrayElements.length;
      }

      // iterar sobre cada grupo de elementos
      groupsElements.forEach(group => {
        // obtener el valor maximo de entre los elementos del grupo actual
        maxValue = 0;
        group.forEach(element => {
          // resetear paramentro para evitor bug
          element.style.setProperty(cssVariable, "unset");
          if (element.offsetHeight > maxValue) {
            maxValue = element.offsetHeight;
          }
        });

        // setear el valor maximo sobre solo los elementos del grupo actual
        group.forEach(element => {
          element.style.setProperty(cssVariable, "".concat(maxValue, "px"));
        });
      });
    }
  };
  document.fonts.ready.then(() => {
    setMaxHeightElements(nodeElementsArray);
  });
  window.addEventListener('resize', () => {
    setMaxHeightElements(nodeElementsArray);
  });
};
/******/ })()
;